<template>
  <main>
    <van-cell-group>
      <van-field
        v-model="phone"
        type="tel"
        required
        clearable
        label="手机号"
        placeholder="请输入手机号"
        @blur="showImageCaptcha"
      />
      <van-field
        v-model="password"
        type="password"
        label="密码"
        placeholder="请输入密码"
        required
      />
      <van-field
        v-model="imageCaptcha"
        center
        clearable
        label="图形验证码"
        placeholder="请输入图形验证码"
      />
      <img
        v-if="imageCaptchaShow"
        :src="imageCaptchaURL"
        alt=""
        class="image-captcha"
        @click="getImageCaptchaURL">
      <van-field
        v-model="captcha"
        center
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
      >
        <van-button
          slot="button"
          :disabled="disabled"
          size="small"
          type="default"
          @click="handleSendSmsCode">{{ sendText }}</van-button>
      </van-field>
    </van-cell-group>
    <div class="p-3">
      <van-row class="pb-2">
        <van-col span="24">
          <van-button
            type="primary"
            size="large"
            @click="handleRegister">注册</van-button>
        </van-col>
      </van-row>
      <van-row class="pb-2">
        <van-col
          span="24"
          class="text-center">
          <router-link :to="{name: 'login'}">已有账号？立即登录</router-link>
        </van-col>
      </van-row>
    </div>
  </main>
</template>

<script>
import JSEncrypt from 'jsencrypt';
import { apiURL, rsaPublicKey } from '@/libs/const';

export default {
  name: 'Register',
  data() {
    return {
      phone: '',
      password: '',
      captcha: '',
      imageCaptcha: '',
      imageCaptchaShow: false,
      imageCaptchaURL: '',
      timer: null,
      sendText: '发送验证码',
      disabled: false,
    };
  },
  deactivated() {
    clearInterval(this.timer);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    showImageCaptcha() {
      const { phone } = this;
      if (phone) {
        this.getImageCaptchaURL();
        this.imageCaptchaShow = true;
      } else {
        this.imageCaptchaShow = false;
      }
    },
    async getImageCaptchaURL() {
      const { phone } = this;
      if (phone) {
        const random = Math.random() * 10;
        this.imageCaptchaURL = `${apiURL}/patient-api/webapi/hospital-patient/get-image-captcha?phone=${phone}&captcha_type=Register&${random}`;
      }
    },
    setSendBtn() {
      let second = 90;
      this.disabled = true;
      this.timer = setInterval(() => {
        this.sendText = `重新发送(${second})`;
        second -= 1;
        if (second <= 0) {
          this.sendText = '发送验证码';
          this.disabled = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    async handleSendSmsCode() {
      const { phone, imageCaptcha } = this;
      await this.$http.post('/patient-api/webapi/hospital-patient/send-sms-captcha', {
        phone,
        captcha_type: 'Register',
        image_captcha: imageCaptcha,
      });
      this.setSendBtn();
    },
    async handleRegister() {
      const { phone, password, captcha } = this;
      const openId = localStorage.getItem('open_id');
      const jsencrypt = new JSEncrypt();
      jsencrypt.setPublicKey(rsaPublicKey);
      await this.$http.post('/patient-api/webapi/weixin/mp/register', {
        phone,
        captcha,
        name: this.phone,
        password: jsencrypt.encrypt(password),
        category: '2',
        open_id: openId,
      });
      this.$toast.success('注册成功');
      this.$router.push({ name: 'home' });
    },
  },
};
</script>

<style>
.image-captcha {
  position: absolute;
  top: 95px;
  right: 16px;
  z-index: 1000;
}
</style>
